export {URLSearchParams} from 'whatwg-url-without-unicode';
